// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3qg7H","list":"PatternAutocomplete_list__I2zvj"};